import Menu from "@mui/material/Menu";
/* eslint-disable quote-props */
import { styled } from "@mui/material";

const GvCustomMenu = styled(Menu)(({ theme }) => ({
  "& .MuiMenu-paper": {
    width: "14.25rem",
    border: `1px solid ${theme.palette.taupe.dark}`,
    borderRadius: "0.5rem",
    boxShadow: "2px 2px 18px 0px rgba(55, 54, 23, 0.30)",
    // boxShadow: "0px 4px 4px rgba(214, 199, 186, 0.25)",
    // padding: "0.5rem 0",
    "& .MuiMenuItem-root": {
      padding: "0.75rem",
    },
    "& .MuiMenu-list": {
      paddingTop: "0",
      paddingBottom: "0",
    },
  },
  "&.Mui-focusVisible, &:hover": {
    backgroundColor: "transparent", // here Overriding background color on focus or hover
  },
  "&.Mui-selected": {
    backgroundColor: "transparent", // here Overriding background color if selected
  },
}));

export default GvCustomMenu;
